<template>
  <div class="content">
    <div class="form-field">
      <popup-button button-text="Добавить авто">
        <add-auto v-bind:plot="id" v-on:auto-add="getPlotData"></add-auto>
      </popup-button>
    </div>
    <table class="table-container">
      <tr class="table-header">
        <th>ФИО собственника машины</th>
        <th>Тип ТС</th>
        <th>Цвет</th>
        <th>Рег знак</th>
        <th>Основной</th>
        <th>Тип проезда</th>
      </tr>
      <tr v-for="(face, key) in faces" :key="key" class="table-row">
        <td>{{ face.USER_NAME }}</td>
        <td>{{ face.AUTO.TYPE_VEHICLES }}</td>
        <td>{{ false }}</td>
        <td>{{ face.AUTO.NUMBER }}</td>
        <td>{{ false }}</td>
        <td>{{ face.IDENTIFIER.TAG_TYPE }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import config from "@/config";
import AddAuto from "../add/Auto";

export default {
  name: "TabAuto",
  components: {AddAuto},
  data() {
    return {
      id: this.$route.params.id,
      url: config.backend_url,
      faces: []
    };
  },
  computed: {},
  watch: {},
  methods: {
    getPlotData: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "plots/get-plot-pass/",
          data: { ID: this.id },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          console.log(data);
          if (!data.error) this.faces = data;
        });
    }
  },
  created() {
    this.getPlotData();
  }
};
</script>
